module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Localização de Veículo")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "patio"
    }
  }, [_vm._v("Patio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patio),
      expression: "patio"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Não selecione caso não queira uma filtragem por pátio",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.patio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectedPatio]
    }
  }, [_c('option', {
    staticStyle: {
      "font-weight": "bold"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione um patio")]), _vm._v(" "), _vm._l((_vm.patiosComputed), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.value
      }
    }, [_vm._v(_vm._s(cat.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "autocomplete-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroInput.titulo),
      expression: "filtroInput.titulo"
    }],
    ref: "grv",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Placa ou número da GRV"
    },
    domProps: {
      "value": (_vm.filtroInput.titulo)
    },
    on: {
      "blur": function($event) {
        return _vm.setVisibilityOptionsAutocomplete(false)
      },
      "keyup": _vm.getListaGrvs,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtroInput, "titulo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOptionsAutocomplete),
      expression: "showOptionsAutocomplete"
    }],
    staticClass: "list-group"
  }, [(_vm.loading) ? _c('li', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : (!_vm.listaGrvs.length) ? _c('li', {
    staticClass: "text-danger"
  }, [_vm._v("Grv não encontrada")]) : _vm._l((_vm.listaGrvs), function(item) {
    return _c('li', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.setFiltroInput(item)
        }
      }
    }, [_vm._v(_vm._s(item.numero) + " - " + _vm._s(item.placa))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Atendente")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.atendente),
      expression: "data.atendente"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "atendente", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.atendentes), function(atendente) {
    return _c('option', {
      key: atendente.id,
      domProps: {
        "value": atendente.id
      }
    }, [_vm._v(_vm._s(atendente.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Vaga")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.vaga),
      expression: "data.vaga"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "vaga",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.vaga)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "vaga", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h2', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                        Fotos do veículo\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Foto")]), _vm._v(" "), _c('th', [_vm._v("Tipo arquivo")]), _vm._v(" "), _c('td', [_vm._v("Excluir")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.data.arquivos), function(arquivo, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (arquivo.descricao),
        expression: "arquivo.descricao"
      }],
      staticClass: "form-control",
      attrs: {
        "id": 'arquivo-desc' + index,
        "type": "text"
      },
      domProps: {
        "value": (arquivo.descricao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(arquivo, "descricao", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "position": "relative",
        "display": "flex",
        "justify-content": "center",
        "align-items": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_c('a', [(arquivo.tipo !== 3) ? _c('img', {
      staticClass: "img-preview",
      attrs: {
        "src": arquivo.imageInfo && (arquivo.imageInfo.thumb ? arquivo.imageInfo.thumb : arquivo.imageInfo.full)['url'] || arquivo.arquivo || arquivo.thumb || '',
        "alt": "foto-veiculo",
        "loading": "lazy"
      }
    }) : _c('span', [_vm._v("Ver assinatura")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_c('div', [_c('span', [_vm._v("." + _vm._s(arquivo.tipo))])])]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button",
        "value": index
      },
      on: {
        "click": function($event) {
          return _vm.excluirFoto(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), _vm._v(" "), (!_vm.data.arquivos || _vm.data.arquivos.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Nenhum arquivo nesta GRV")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "wrapper-sm m-t-n m-b"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "fileInptImg",
    attrs: {
      "type": "file",
      "name": "files[]",
      "id": "fileInptImg",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadFoto
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv btnPicDesktop",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openMultipleInputFile('fileInptImg')
      }
    }
  }, [_vm._v("\n                     Adicionar "), _c('i', {
    staticClass: "fa fa-picture-o"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("* Você pode selecionar mais de uma foto ao mesmo tempo para enviar")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', [_vm._v("Salvar")])])], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ca9519e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/roubo-furto/components/LocalizacaoVeiculo.vue
// module id = 1558
// module chunks = 17